angular.module('bb.appointments.feedback').config(appointmentsRoutes);

appointmentsRoutes.$inject = ['$routeProvider'];
function appointmentsRoutes($routeProvider) {
  $routeProvider
    .when('/listing/:listingId/appointments/feedback_settings', {
      template: `<bb-feedback-settings/>`,
    })
    .when('/listing/:listingId/feedbacks', {
      template: `<bb-feedback-list/>`,
    })
    .when('/listing/:listingId/feedbacks/:appointmentId', {
      template: `<bb-feedback-list/>`,
    });
}

export {};
